import { render, staticRenderFns } from "./LessonProgressSwiper.vue?vue&type=template&id=83fb29d2&scoped=true&"
import script from "./LessonProgressSwiper.vue?vue&type=script&lang=js&"
export * from "./LessonProgressSwiper.vue?vue&type=script&lang=js&"
import style0 from "./LessonProgressSwiper.vue?vue&type=style&index=0&id=83fb29d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fb29d2",
  null
  
)

export default component.exports